import React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import themes from '../../../theme'
import styles from './FlatLabelsStyles'
import { colorFilterTextSelected, colorFilterIconUnselected, PostTagsTheme } from '../../../themeConstants'

const FlatLabels = ({ posts, onSelectLabel }) => {
    const textStyle = posts.isSelected ? styles.flatItemsSelected : styles.flatItemsUnselected

    return (
        <TouchableOpacity
            onPress={() => onSelectLabel(posts._id)}
            style={[styles.flatFlags, { backgroundColor: posts.isSelected ? PostTagsTheme.tagSelectedColor : PostTagsTheme.tagUnselectedColor }]}
        >
            <Text fontSize='normalText' color='textPrimary' style={textStyle}>
                {posts.name}
            </Text>
        </TouchableOpacity>
    )
}

export default FlatLabels
